import campaigns from "./campaigns";
import assets from "./assets";
import ui from "./ui";
import deliverNew from "./deliverNew";
import deliveries from "./deliveries";
import campaignsPage from "./campaignsPage";
import activeUser from "./activeUser";
import nativeResolutions from "./nativeResolutions";
import requiredResolutions from "./requiredResolutions";
import users from "./users";
import userGroups from "./userGroups";
import agencys from "./agencys";
import printSizes from "./printSizes";
import campaignTable from "./campaignTableState";
import attachmentProgress from "./oldAssetsAttachmentState";
import reactTableAssets from "./reactTableAssets";
import reactTableUserManagement from "./reactTableUserManagement";
import reactTableDeliveries from "./reactTableDeliveries";
import oldAssets from "./oldAssets";

import approvers from "./approvers";
import approvals from "./approvals";

export default {
  campaigns,
  assets,
  ui,
  deliverNew,
  deliveries,
  campaignsPage,
  activeUser,
  nativeResolutions,
  requiredResolutions,
  users,
  userGroups,
  agencys,
  printSizes,
  campaignTable,
  attachmentProgress,
  reactTableAssets,
  reactTableUserManagement,
  reactTableDeliveries,
  oldAssets,

  approvers,
  approvals,
};
